export default "__VITE_ASSET__IYRwa9c3__"